(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cx-b2b-enterprise"] && !Shopify.designMode) return;
  try {
    function cxbeBuild(values) {
  const errors = [];
  const isBlank = value => String(value ?? '').trim() === '';
  for (const key of ['total', 'locations']) {
    const n = Number(values[key]);
    if (isBlank(values[key]) || !Number.isInteger(n) || n < 1 || n > (key === 'total' ? 1000000 : 100000)) errors.push(key);
  }
  const rx = isBlank(values.rx) ? null : Number(values.rx);
  if (rx !== null && (!Number.isInteger(rx) || rx < 0 || rx > 1000000 || rx > Number(values.total))) errors.push('rx');
  let allowance = null;
  if (values.allowanceState === 'known') {
    allowance = Number(values.allowance);
    if (isBlank(values.allowance) || !Number.isFinite(allowance) || allowance < 0 || allowance > 1000000 || Math.abs(allowance * 100 - Math.round(allowance * 100)) > 0.00001) errors.push('allowance');
  }
  if (errors.length) return {errors};
  return {errors: [], total: Number(values.total), rx, locations: Number(values.locations), allowance};
}
function cxbeInit() {
  document.querySelectorAll('[data-cxbe-inquiry]').forEach(link => {
    if (link.dataset.ready) return;
    link.dataset.ready = 'true';
    link.addEventListener('click', () => {
      const message = document.getElementById('cxb3-body');
      const intent = link.dataset.cxbeInquiry;
      if (message && intent && !message.value.includes(intent)) {
        message.value = message.value.trim() ? message.value + '\n\n' + intent : intent;
        message.dispatchEvent(new Event('input', {bubbles: true}));
      }
    });
  });
  const report = document.getElementById('cxbe-report');
  if (report && !report.dataset.ready) {
    report.dataset.ready = 'true';
    const tabs = [...report.querySelectorAll('[role="tab"]')];
    const activate = tab => {
      tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !selected;
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); activate(next); next.focus(); }
      });
    });
  }
  const form = document.getElementById('cxbe-builder-form');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const inputs = [...form.querySelectorAll('input[type="number"]')];
  const state = document.getElementById('cxbe-allowance-state');
  const allowance = document.getElementById('cxbe-allowance');
  const allowanceField = document.getElementById('cxbe-allowance-field');
  const result = document.getElementById('cxbe-builder-result');
  const status = document.getElementById('cxbe-builder-status');
  let latest = null, previousInquiry = '';
  const syncAllowance = () => { allowance.disabled = state.value !== 'known'; allowanceField.hidden = allowance.disabled; };
  const invalidate = () => {
    inputs.forEach(input => input.removeAttribute('aria-invalid'));
    latest = null;
    if (!result.hidden) { result.hidden = true; status.textContent = form.dataset.stale; }
  };
  state.addEventListener('change', syncAllowance);
  form.addEventListener('input', invalidate);
  form.addEventListener('change', invalidate);
  syncAllowance();
  form.querySelector('[type="submit"]').disabled = false;
  form.addEventListener('submit', event => {
    event.preventDefault();
    const values = {allowanceState: state.value};
    inputs.forEach(input => { values[input.name] = input.value; input.removeAttribute('aria-invalid'); });
    const built = cxbeBuild(values);
    if (built.errors.length) {
      result.hidden = true;
      latest = null;
      status.textContent = form.dataset.invalid;
      built.errors.forEach(key => document.getElementById('cxbe-' + key).setAttribute('aria-invalid', 'true'));
      document.getElementById('cxbe-' + built.errors[0]).focus();
      return;
    }
    const goals = [...form.querySelectorAll('[name="priority"]:checked')].map(input => input.dataset.label);
    const money = value => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2}).format(value);
    latest = {
      total: built.total.toLocaleString('en-US'),
      rx: built.rx === null ? form.dataset.unknown : built.rx.toLocaleString('en-US'),
      locations: built.locations.toLocaleString('en-US'),
      allowance: built.allowance === null ? state.options[state.selectedIndex].textContent : form.dataset.allowanceFormat.replace('[amount]', money(built.allowance)),
      goals: goals.length ? goals.join(', ') : form.dataset.none
    };
    for (const key of Object.keys(latest)) form.querySelector('[data-result="' + key + '"]').textContent = latest[key];
    result.hidden = false;
    status.textContent = form.dataset.readyText;
  });
  form.querySelector('[data-builder-quote]').addEventListener('click', event => {
    if (!latest) { event.preventDefault(); return; }
    const message = document.getElementById('cxb3-body');
    if (!message) return;
    const intent = form.dataset.inquiry.replace(/\[(total|rx|locations|allowance|goals)\]/g, (_, key) => latest[key]);
    let existing = message.value;
    if (previousInquiry && existing.includes(previousInquiry)) existing = existing.replace(previousInquiry, '').trim();
    if (!existing.includes(intent)) message.value = existing.trim() ? existing.trim() + '\n\n' + intent : intent;
    previousInquiry = intent;
    message.dispatchEvent(new Event('input', {bubbles: true}));
  });
  form.addEventListener('reset', () => {
    latest = null;
    result.hidden = true;
    status.textContent = form.dataset.empty;
    inputs.forEach(input => input.removeAttribute('aria-invalid'));
    allowance.disabled = true;
    allowanceField.hidden = true;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cxbeInit); else cxbeInit();
document.addEventListener('shopify:section:load', cxbeInit);
  } catch(e) { console.error(e); }
})();

})();
